// 화면 연출(CLEAR·카드 뽑기) 전용 효과음 자리(slot). 소리 파일은 public/assets/audio/ui/<이름>.mp3 에 나중에 넣는다(지휘 쪽 FlowMusic 제작).
// 실제로 들어 있는 파일만 UI_SLOT_FILES에 적고, 로딩은 그 목록의 파일만 내려받는다(없는 파일을 요청해 404가 나지 않게).
// 목록에 없는 자리는 처음부터 아래 기존 효과음으로 낸다. 파일을 넣으면 UI_SLOT_FILES에도 적는다 — 어긋나면 uiSlots.test.ts가 실패한다.
import type { SfxName } from './sounds';

export const UI_SLOT_NAMES = ['cardLand', 'cardFlip', 'cardReveal', 'cardLegend', 'clearLogo'] as const;
export type UiSlotName = (typeof UI_SLOT_NAMES)[number];

/** public/assets/audio/ui/ 에 실제로 들어 있는 파일(자리 이름). 파일을 넣을 때 여기에도 추가한다 */
export const UI_SLOT_FILES: ReadonlySet<UiSlotName> = new Set<UiSlotName>([]);

export interface UiSlotDef {
  /** 파일이 없을 때 쓸 기존 효과음 */
  readonly fallback: SfxName;
  /** 파일 대비 음량(dB). 파일은 피크 -1dBFS로 맞춘다고 본다 */
  readonly gainDb: number;
  /** 설명(제작 의뢰용) */
  readonly note: string;
}

export const UI_SLOTS: Readonly<Record<UiSlotName, UiSlotDef>> = {
  cardLand: { fallback: 'gateClose', gainDb: -6, note: '뒷면 카드가 날아와 탁 하고 착지(0.2초 이내, 카드 3장이 차례로 겹치지 않게 짧게)' },
  cardFlip: { fallback: 'uiClick', gainDb: -6, note: '카드가 휙 뒤집히는 소리(0.25초 이내)' },
  cardReveal: { fallback: 'awakenFlash', gainDb: -4, note: '희귀·영웅 카드 등급 빛이 터지는 소리(반짝 + 짧은 상승음 0.6초 이내)' },
  cardLegend: { fallback: 'levelUp', gainDb: -2, note: '전설 카드 공개: 묵직한 타격 + 금빛 팡파르(1.2초 이내)' },
  clearLogo: { fallback: 'hitFinisher', gainDb: -2, note: 'CLEAR 로고가 쾅 떨어지는 소리(저역 임팩트 + 짧은 징글 0.8초 이내)' },
};

export function isUiSlot(name: string): name is UiSlotName {
  return Object.prototype.hasOwnProperty.call(UI_SLOTS, name);
}
export function uiSlotPath(name: UiSlotName, base = 'assets/audio/ui/'): string {
  return base + name + '.mp3';
}
